import { Typography } from '../../components/primitives';
import { ProjectsProvider } from '../../context/projects.context';
import { Projects } from '../projects/projects';
import { useTranslation } from '@rpi/i18n';

export const ProjectsRoute = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.projects' });

  return (
    <div className="space-y-12 flex flex-col">
      <Typography as="h1" variant="title-default">
        {t('projects_title')}
      </Typography>
      <ProjectsProvider>
        <Projects />
      </ProjectsProvider>
    </div>
  );
};
